(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const initFaqItems = (root = document) => {
      root.querySelectorAll('.faq-item').forEach((item) => {
        if (item.dataset.faqAnimated == 'true') return;

        const summary = item.querySelector('.faq-item__summary');
        if (!summary) return;

        item.dataset.faqAnimated = 'true';

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.dataset.faqAnimating == 'true') return;

          const isOpen = item.open;
          const startHeight = `${item.offsetHeight}px`;
          const className = isOpen ? 'is-closing' : 'is-opening';

          item.dataset.faqAnimating = 'true';
          item.style.height = startHeight;

          if (!isOpen) {
            item.open = true;
          }

          const endHeight = isOpen ? `${summary.offsetHeight}px` : `${item.scrollHeight}px`;

          item.classList.add(className);

          item.offsetHeight;

          requestAnimationFrame(() => {
            item.style.height = endHeight;
          });

          const finish = (transitionEvent) => {
            if (transitionEvent.target != item || transitionEvent.propertyName != 'height') return;

            if (isOpen) {
              item.open = false;
            }

            item.style.height = '';
            item.classList.remove(className);
            item.dataset.faqAnimating = 'false';
            item.removeEventListener('transitionend', finish);
          };

          item.addEventListener('transitionend', finish);
        });
      });
    };

    initFaqItems();

    document.addEventListener('shopify:section:load', (event) => {
      initFaqItems(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
